export const config = {
  basePath: 'docs/',
  homepage: 'README.md',
  notFoundPage: '/_404.md',
  sideLoad: {
    sidebar: '/_sidebar.md',
    navbar: '/_navbar.md',
    rightSidebar: '/_sidebar2.md',
    footer: '/_footer.md'
  },
  coverpage: '_coverpage.md'
};
